import Icon from 'veui/components/Icon'
import { IconIdCardBack } from 'dls-icons-vue'

Icon.register('id-card-back', IconIdCardBack)
